import React from "react";

const CountrySelector = ({ name, img }) => {
	return (
		<div>
			<div className="main-select-value">
				<div>
					<img src={img} alt={name} />
					<div className="cont d-flex align-items-center">
						<span>{name}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CountrySelector;
